import { useEffect } from 'react'
import {
  IIntelligentRecommendationsEventTypeEnum,
  ISendIntelligentRecommendationsEventInput,
  Maybe,
} from 'types/FMSGraphqlTypes'
import { useFMSAnalytics } from 'apps/fleet-planner/hooks/useFMSAnalytics'
import { useTrackIntelligentRecEventMutation } from '../graphql/TrackIntelligentRecEvent'

type ITrackIntelligentRecEventFunction = (input: ISendIntelligentRecommendationsEventInput) => void

interface IUseTrackIntelligentRecsState {
  trackIntelligentRecEvent: ITrackIntelligentRecEventFunction
}

export const useTrackIntelligentRecs = (): IUseTrackIntelligentRecsState => {
  const { trackEvent } = useFMSAnalytics()
  const [track, { error: apolloError }] = useTrackIntelligentRecEventMutation()

  const trackErrors = ({
    errors,
    input,
  }: {
    errors: any
    input: Maybe<ISendIntelligentRecommendationsEventInput>
  }) => {
    const { intelligentRecsEventType: eventType } = input || {}
    if (eventType === IIntelligentRecommendationsEventTypeEnum.click) {
      trackEvent('Loads for You', 'ERROR_SENDING_SNOWFLAKE_CLICK', { input, errors })
    } else {
      trackEvent('Loads for You', 'ERROR_SENDING_SNOWFLAKE_VIEW', { input, errors })
    }
  }

  const trackIntelligentRecEvent: ITrackIntelligentRecEventFunction = async input => {
    try {
      const { data, errors: gqlErrors = [] } = await track({
        variables: { input },
      })
      const { sendIntelligentRecommendationsEvent } = data || {}
      const { errors = [] } = sendIntelligentRecommendationsEvent || {}

      if (errors && errors.length > 0) {
        trackErrors({ errors, input })
      }

      if (gqlErrors.length > 0) {
        trackErrors({ errors: gqlErrors, input })
      }
    } catch (e) {
      trackErrors({ errors: e, input })
    }
  }

  useEffect(() => {
    if (apolloError) {
      trackEvent('Loads for You', 'APOLLO_ERROR_OCCURRED', { apolloError })
    }
  }, [apolloError, trackEvent])

  return {
    trackIntelligentRecEvent,
  }
}
